import React, { useContext } from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import LinkIcon from "../../images/link.svg"

const Aside = styled.aside`
    position: sticky;
    top: 4rem;
    list-style: none;
    padding: 4rem 0 3rem;
    min-width: 170px;
    max-width: 250px;
    margin-right: 4rem;
    @media screen and (max-width: ${(props) => props.theme.breakpoints.phone}) {
       margin-right: 0;
      max-width: inherit;
       padding: 2rem 0 0rem;
    }

  h2 {
    font-size: 28px;
    padding: 0 1rem;
    font-family: ${(props) => props.theme.fontCondensed};
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li {
        svg {
            padding-left: 1rem;
            top: 3px;
            position: relative;
        }
      display: flex;
      font-family: ${(props) => props.theme.fontCondensed};
      flex-direction: row;
        padding: 0.5rem 0 0.5rem;
      margin: 0;
      border-bottom: 2px solid ${props => props.theme.colors.primary};
      &.active {
        background: ${props => props.theme.colors.primary};
        color: #fff;
        span:first-of-type {
          color: ${props => props.theme.colors.primary};
        }
      }
    }
  }
`

const Sticky = styled.div`
  position: sticky;
  top: 4rem;
  height: auto;
`

const Sidenav = styled.nav`
    width: 28%;
    position: fixed;
    height: 100%;
    @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
        display: none;
    }
    
`
const Navigation = styled.ul`
    list-style: none;
    padding: 0;
    /* margin: -1rem 0 0; */
    margin: 0;
  a {
    font-size: 14px;
    font-family: ${(props) => props.theme.fontBold};
    line-height: 1.4;
    color: ${(props) => props.theme.colors.primary};
    text-decoration: none;
    
    transition: 0.2s;
    
    // &:hover,
    // &[aria-current="page"],
    // &.active {
    //   border-bottom: 2px solid ${(props) => props.theme.colors.primary};
    // }
    
  }
  a.grow {
    position: relative;
  }
  a.grow:before {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    bottom: -4px;
    left: 0;
    background-color: ${(props) => props.theme.colors.secondary};
    visibility: hidden;
    width: 0;
    transition: all 0.2s ease-in-out;
  }
  a.grow:hover:before {
    visibility: visible;
    width: 100%
  }
  a.grow.active:before {
    visibility: visible;
    width: 100%
  }
  li {
    margin: 1rem 1.5rem;
    &:last-child {
      margin-right: 0;
    }
  }
`;

interface IProps {
  currentArticle: string
}

const AboutSidemenu = () => {

  return (
    <Aside>
      <Sticky>
        <Navigation>
            <li className="future">
                <Link to="#106" className="future" activeClassName="active">
                    107 years strong
                </Link>
            </li>
            <li className="proposal">
                <Link to="#contacts" activeClassName="active">
                    Useful contacts
                </Link>
            </li>
        </Navigation>
      </Sticky>
    </Aside>
  )
}

export default AboutSidemenu



